module.exports = __webpack_public_path__ + "static/media/companykitchenSnackGift.c8c63ae5.gif";